const fixNum = (n, digits) => Number(n?.toFixed(digits))

export default fixNum
